











import ConnectionInfo from '@/components/ConnectionInfo.vue'
import gql from '../gqlService.coffee'

export default {
    "name": ""
    "components": {ConnectionInfo}
    "props": {
        "autoload": Boolean
    }
    "computed":{
        "computed_filters": ()->
            return {
                "establishment__uid": this.$store.state.selected_establishment_uid
            }
    }
    "data": ()->
        return {
            "connection_set": new gql.DataHolder({
                "model": "connection_set",
                "fields": "uid login password info establishment_link platform{name}"
                "autoload": this.autoload,
                "filters": null
            })
        }
    "methods":
        "query": ()->
            vm = this
            vm.connection_set.query(vm.computed_filters)
    "watch":
        "$store.state.selected_establishment_uid": (newV, oldV)->
            if newV?
                this.query()
}
